/**
 * @file Waldo's main logo.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { getAsset } from '../../util/assets';

const propTypes = {
  logoSrc: PropTypes.string,
  linksTo: PropTypes.string,
  className: PropTypes.string,
  externalLink: PropTypes.bool,
  iconOnly: PropTypes.bool,
  imageProps: PropTypes.object,
};

const Logo = ({
  logoSrc,
  linksTo,
  className,
  externalLink = false,
  iconOnly = false,
  imageProps = {},
}) => {
  const classes = classNames({
    'site-logo': true,
    [className]: !!className,
  });
  const imageSrc = iconOnly
    ? getAsset('/waldo-icon.svg')
    : logoSrc || getAsset('/waldo-logo.svg');

  const logo = <img src={imageSrc} alt="Waldo Logo" {...imageProps} />;

  if (!linksTo) {
    return <span className={classes}>{logo}</span>;
  }

  return externalLink ? (
    <a href={linksTo} className={classes}>
      {logo}
    </a>
  ) : (
    <Link to={linksTo} className={classes}>
      {logo}
    </Link>
  );
};

Logo.propTypes = propTypes;

export default Logo;
